'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module3Res6 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module3Res6, _Component);

  function Module3Res6() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module3Res6);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module3Res6.__proto__ || (0, _getPrototypeOf2.default)(Module3Res6)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      module: 'Module 3',
      title: 'Dealing with misbehaviour'
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module3Res6, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                this.state.module
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12, xs: 12, sm: 12 },
                _react2.default.createElement(
                  'p',
                  { className: styles.orangeText },
                  'No strategy works perfectly every time. If a child is misbehaving, parents could try introducing a logical consequence or a timeout.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'What is a logical consequence?'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'This is when you ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'remove an object or activity because your child is misbehaving. '
                  ),
                  'For example, taking away a drinking straw because your child is using it to squirt water. This should happen immediately but only for a short amount of time (5 minutes). After a few minutes, bring the object or activity back so that your child has the opportunity to use it correctly. If they do, you can praise them for doing the right thing.'
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'What is a time out?'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Sometimes it is helpful to ',
                  _react2.default.createElement(
                    'strong',
                    { className: styles.orangeText },
                    'take a child away from an activity when they are misbehaving'
                  ),
                  '. Instead, children must wait in a \'time-out\' area for a set amount of time before they can play again. The time-out area can be in the same room (ie. the corner or a chair), or in a different room.'
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module3Res6;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module3Res6;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/3/Res6.js
// module id = 1252
// module chunks = 0